import { Button, Drawer, Flex, Stack, Text } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import FieldText from '@/components/shared/form/FieldText';
import DrawerLayout from '@/components/ui/DrawerLayout';
import TreeNode from '@/components/ui/TreeNode';
import { IconFolder } from '@/components/ui/icons/IconFolder';
import { useSidebarDocumentsStore } from '@/stores/local/sidebar/SidebarDocumentsStore';

import ParentTreeSelect from './ParentTreeSelect';

import s from './CreateFolderPopup.module.scss';

const CreateFolderPopup: React.FC = () => {
  const {
    popups: { createFolderPopup },
  } = useSidebarDocumentsStore();

  const { form, isParentSelectable, parentFolder } = createFolderPopup;
  const isEdit = Boolean(createFolderPopup.entity);

  const renderPlacementSection = () => {
    if (isParentSelectable) {
      return (
        <Stack gap="xs">
          <Text size="sm" fw={400}>
            Выберите папку
          </Text>
          <ParentTreeSelect />
        </Stack>
      );
    }

    if (parentFolder) {
      return (
        <Stack gap="xs">
          <Text size="sm" fw={400}>
            Разместить в
          </Text>
          <div className={s.root__selectedFolder}>
            <TreeNode level={1} isOpen={false} withArrow={false} icon={<IconFolder />} title={parentFolder.name} />
          </div>
        </Stack>
      );
    }

    return null;
  };

  return (
    <Drawer
      classNames={{ body: s.root }}
      title={<Text fw="500">{isEdit ? 'Редактировать папку' : 'Создать папку'}</Text>}
      opened={createFolderPopup.isOpen}
      onClose={createFolderPopup.close}
      position="left"
    >
      <DrawerLayout
        actions={
          <Flex align="flex-end">
            <Button loading={form.meta.isLoading} onClick={form.submit}>
              <Text fw="400">Сохранить</Text>
            </Button>
          </Flex>
        }
      >
        <Stack gap="lg">
          <Stack gap="xs">
            <FieldText
              classNames={{ input: s.root__input }}
              placeholder={form.dateFormatPlaceholder}
              label={
                <Text className={s.root__required} size="sm">
                  Название
                </Text>
              }
              store={form.fieldsMap.name}
            />
          </Stack>
          {renderPlacementSection()}
        </Stack>
      </DrawerLayout>
    </Drawer>
  );
};

export default observer(CreateFolderPopup);
